import { render, staticRenderFns } from "./CommonEmployeeDetailsModal.vue?vue&type=template&id=010fa4ea&scoped=true&"
import script from "./CommonEmployeeDetailsModal.vue?vue&type=script&lang=js&"
export * from "./CommonEmployeeDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010fa4ea",
  null
  
)

export default component.exports